import { ReactNode } from 'react';
import classes from './PageLayout.module.css';

type PageLayoutProps = {
  children: ReactNode;
  topSection?: ReactNode;
};

export const PageLayout = ({
  children,
  topSection
}: PageLayoutProps) => {
  return (
    <div className={classes.pageLayout}>
      {topSection && (
        <div className={classes.topSection}>
          {topSection}
        </div>
      )}
      <div className={classes.content}>
        {children}
      </div>
    </div>
  );
};
